import { createApiAddress } from 'common/helpers';

class PublicDocumentsService {
  private static instance: PublicDocumentsService | null = null;

  private constructor() {}

  static getInstance(): PublicDocumentsService {
    if (this.instance == null) {
      this.instance = new PublicDocumentsService();
    }

    return this.instance;
  }

  privacyPolicyHref() {
    return createApiAddress('/client/documents/privacy_policy');
  }

  consentHref() {
    return createApiAddress('/client/documents/consent');
  }
}

export default PublicDocumentsService;
